import { IFieldAccessType } from '../../../../../component/admin-module/module/users/interface/field';
import ValidateField from '../../../validation';
import { IValidationError } from '../../../validation/type/validation-type';
import { FieldElement } from '../../field-element';
import { TValidationType, PropType } from '../field-properties.handler';

interface IDateTimeProps {
  value: string;
  error?: IValidationError[];
  fieldType?: string;
}
export class DateTimeProps extends PropType<IDateTimeProps, IDateTimeProps> {

  processValueFromRef(props: IDateTimeProps): IDateTimeProps {
    props.value = props.value || '';
    return props;
  }

  processValueToRef(newProps: IDateTimeProps): IDateTimeProps {
    newProps.value = newProps.value || '';
    return newProps;
  }

  processValidation(data: IDateTimeProps | null, field: FieldElement, validationType: TValidationType): IValidationError[] {
    const value = data?.value || '';
    const validateField = new ValidateField();
    const validate = validateField.singleField(field, value || '', validationType);
    return field.accessType === IFieldAccessType.Required || !!value ? validate : [];
  }
}